export default "/images/vendor/flag-icon-css/flags/1x1/is.svg?76481cf550e4750b105cd1dead4a60cb";